import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import BackOfficeUnauthorisedButton from "app/components/BOComponents/BackOfficeUnauthorisedButton";
import ActiveList from "./Ops.ApplicationStatusMessagesActive.List";
import List from "./Ops.ApplicationStatusMessages.List";
import Create from "./Ops.ApplicationStatusMessages.Create";
import Edit from "./Ops.ApplicationStatusMessages.Edit";
import { groupAuth } from "app/utils/authGroups";

const hasPermission = groupAuth.hasAccessGroup(["Ops/Admin"]);

const ApplicationStatusMessages = (props) => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/application_status_messages"
      render={() => (
        <Redirect to="/snapscan/ops/application_status_messages/active" />
      )}
    />
    <Route
      exact={true}
      path="/snapscan/ops/application_status_messages/active"
      render={(routerProps) => <ActiveList {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/application_status_messages/list"
      render={(routerProps) =>
        hasPermission ? (
          <List {...{ ...props, ...routerProps }} />
        ) : (
          <BackOfficeUnauthorisedButton redirectUrl="/snapscan/ops/application_status_messages/active" />
        )
      }
    />
    <Route
      exact={true}
      path="/snapscan/ops/application_status_messages/create"
      render={(routerProps) =>
        hasPermission ? (
          <Create {...{ ...props, ...routerProps }} />
        ) : (
          <BackOfficeUnauthorisedButton redirectUrl="/snapscan/ops/application_status_messages/active" />
        )
      }
    />
    <Route
      exact={true}
      path="/snapscan/ops/application_status_messages/:id/edit"
      render={(routerProps) =>
        hasPermission ? (
          <Edit {...{ ...props, ...routerProps }} />
        ) : (
          <div style={{ margin: "15px" }}>Unauthorized</div>
        )
      }
    />
  </Switch>
);

export default ApplicationStatusMessages;
